import { render, staticRenderFns } from "./headphones.vue?vue&type=template&id=173f45e0&scoped=true&"
import script from "./headphones.vue?vue&type=script&lang=js&"
export * from "./headphones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f45e0",
  null
  
)

export default component.exports